import { useState, useEffect } from 'react';
import '../Styles/Navbar.css';

export function Navbar() {
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 50) {
				setIsScrolled(true);
			} else {
				setIsScrolled(false);
			}
		};

		window.addEventListener('scroll', handleScroll);
		
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<nav className={`nav-bar ${isScrolled ? 'scrolled' : ''}`}>
		<span className="nav-logo">Erik Watchorn Portfolio</span>
		<div className='socials'>
			<a href='/Files/ErikWatchornCV.pdf' 
			target='_blank' 
			className='social-icon' 
			style={{ backgroundImage: "url('/Images/svgs/square-cv-svgrepo-com.svg')" }}
			title='CV'></a>
			
			<a href='https://erikwtn.itch.io' 
			target='_blank' 
			className='social-icon itch-icon' 
			style={{ backgroundImage: "url('/Images/svgs/itchio-logo-textless-white.svg')" }}
			title='Itch.io'></a>

			<a href='https://github.com/erikwtn' 
			target='_blank' 
			className='social-icon github-icon' 
			style={{ backgroundImage: "url('/Images/svgs/github-mark-white.svg')" }}
			title='GitHub'></a>

			<a href='https://www.linkedin.com/in/erik-watchorn-053bb2276/' 
			target='_blank' 
			className='social-icon linkedin-icon' 
			style={{ backgroundImage: "url('/Images/svgs/linkedin-svgrepo-com.svg')" }}
			title='LinkedIn'></a>
		</div>
	</nav>
	)
}